export default "__VITE_ASSET__DE9m_mOO__"